<template>
  <section id="formulario" class="bg-[#57af4e] p-6 plex-regular">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700"
      @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto max-w-7xl bg-white bg-opacity-85 rounded-lg p-6">

        <div class="w-full py-6">
          <h1 class="plex-semibold text-xl text-gray-800">EXPOSITOR</h1>
          <h1 class="plex-semibold text-gray-800">Por favor complete el formulario en su totalidad</h1>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2 md:w-1/5">
            <label class="block mb-1">DNI</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="text" placeholder="DNI / Pasaporte" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="dni" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" placeholder="Nombre" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="nombre" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" placeholder="Apellido" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="apellido" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Empresa</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" placeholder="Empresa" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="empresa" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Tarea que desarrolla</label>
            <Field name="tarea" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.tarea">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :options="tareas"
                optionLabel="descripcion" placeholder="Seleccione la tarea que desarrolla" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="tarea" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/5">
            <label class="block mb-1">CUIT</label>
            <Field name="cuit" v-slot="{ field, errors }" v-model="formData.cuit">
              <InputText v-bind="field" type="text" placeholder="CUIT / Matrícula" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="cuit" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Fecha de nacimiento</label>
            <Field name="fechaNacimiento" v-slot="{ field, errors }" v-model="formData.fechaNacimiento">
              <Calendar v-bind="field" :model-value="formData.fechaNacimiento" placeholder="Fecha de nacimiento"
                dateFormat="dd/mm/yy" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="fechaNacimiento" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/3">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" placeholder="Mail" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="mail" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" label="REGISTRARME"
            class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>
    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import moment from 'moment'

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import Calendar from 'primevue/calendar';

import jsonTareas from '@/data/tareas.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, IdLabelEntity, OrigenAcreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";

interface Tarea extends IdLabelEntity { }

export default defineComponent({
  name: 'FormSection',
  components: {
    InputText, Select, Calendar,
    Field, ErrorMessage, Form
  },
  data() {
    return {
      isSubmitting: false,
      tareas: [] as Tarea[],
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        mail: '',
        fechaNacimiento: new Date(),
        cuit: '',
        tarea: undefined as unknown as Tarea,
        empresa: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required('Ingrese el DNI').min(8, 'Al menos 8 números'),
        nombre: yup.string().required('Ingrese el nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese el apellido').min(3, 'Al menos 3 letras'),
        cuit: yup.string().required('Ingrese el CUIT').min(8, 'Al menos 8 letras'),
        fechaNacimiento: yup.date().required('Ingrese la fecha de nacimiento'),
        empresa: yup.string().required('Ingrese la empresa'),
        tarea: yup.mixed().required('Seleccione la tarea que desarolla'),
        mail: yup.string().required('Ingrese el correo').email('Correo inválido'),
      });
    }
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: "Revise el formulario<br>Hay " + errores + " error/es", icon: "error" });
    },
    async onSubmit() {
      this.isSubmitting = true;

      let acreditado: Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = { "id": this.formData.tarea.id } as TipoAcreditado;
      acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
      acreditado.dni = this.formData.dni;
      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.empresa = this.formData.empresa;
      acreditado.mail = this.formData.mail;
      acreditado.fechaNacimiento = moment(this.formData.fechaNacimiento).format('DD/MM/YYYY'),
        acreditado.modificado = SAVE;
      acreditado.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
      acreditado.cantidad = 1;
      acreditado.notificar = true;

      acreditado.dato3 = this.formData.cuit;

      try {
        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

        Swal.fire({
          title: "Acreditación exitosa",
          html: "Hemos recibido sus datos de acreditación con éxito.<br/>Le enviamos un código QR al mail indicado para agilizar su ingreso al evento.<br/>Si usted tiene problemas para recibir el correo puede acreditarse con su DNI.",
          icon: "success",
        }).then(() => {
          window.location.href = "https://fimar.com.ar";
        });

      } catch (error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    this.tareas = jsonTareas;
  }
});
</script>
